import React, { useState, useContext } from 'react';
import { Modal, Radio, Space, Input, message } from 'antd';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { addReport } from './api';

const REPORT_REASONS = ['behavior', 'language', 'cheating', 'noshow', 'other'];

const ReportModal = ({ visible, onClose, reportedUserId, reportedNickname }) => {
  const { formatMessage } = useIntl();
  const {
    user: [user],
  } = useContext(StoreContext);
  const [reason, setReason] = useState(null);
  const [details, setDetails] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setReason(null);
    setDetails('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!reason) {
      message.warning(formatMessage({ id: 'profile.report.reason.required' }));
      return;
    }
    await addReport(
      {
        reportedUserId,
        reportedNickname,
        reporterUserId: user.uid,
        reporterNickname: user.nickname,
        reason,
        details: details.trim(),
        resolved: false,
        createdAt: new Date(),
      },
      setLoading,
    );
    message.success(formatMessage({ id: 'profile.report.success' }));
    handleClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      title={formatMessage(
        { id: 'profile.report.modal.title' },
        { name: reportedNickname },
      )}
      okText={formatMessage({ id: 'profile.report.submit' })}
      cancelText={formatMessage({ id: 'common.cancel' })}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose>
      <Radio.Group
        value={reason}
        onChange={e => setReason(e.target.value)}
        style={{ marginTop: 8 }}>
        <Space direction="vertical">
          {REPORT_REASONS.map(r => (
            <Radio key={r} value={r}>
              {formatMessage({ id: `profile.report.reason.${r}` })}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <Input.TextArea
        style={{ marginTop: 16 }}
        rows={3}
        placeholder={formatMessage({ id: 'profile.report.details.placeholder' })}
        value={details}
        onChange={e => setDetails(e.target.value)}
        maxLength={300}
        showCount
      />
    </Modal>
  );
};

export default ReportModal;
